import * as React from "react";

import { useFormObject } from "../../FormObjectProvider";

import { FormName, HintWithLink, Cards } from "./FormInfo.styles";
import { PeriodBeginNew } from "./PeriodBeginNew";
import { DateRelease } from "./DateRelease";
import { Condition } from "./Condition";
import { LinkInfo } from "./LinkInfo";
import { CalendarInfo } from "./CalendarInfo";

interface ActualInfoAboutFormProps {
    name: string | undefined;
    relevance: boolean | undefined;
    relevanceMessage: string | undefined;
    notice: string | undefined;
    periodBeginNew: string | undefined;
    dateRelease: string | undefined;
    reportingDeadlines: string | undefined;
    version: string | undefined;
    periodDescription: string | undefined;
}

function joinString(text: string | undefined): string {
    if (text !== undefined) {
        const splitText = text.split("|");
        const firstPart = splitText[0] ?? "";
        const secondPart = splitText[1] ?? "";
        if (firstPart && secondPart) {
            return `${firstPart}, ${secondPart}`;
        }
        if (!firstPart && secondPart) {
            return `${secondPart[0]?.toUpperCase()}${secondPart.slice(1)}`;
        }
        if (firstPart && !secondPart) {
            return `${firstPart[0]?.toUpperCase()}${firstPart.slice(1)}`;
        }
    }
    return "";
}

export const ActualInfoAboutForm = (props: ActualInfoAboutFormProps) => {
    const joinReportingDeadlines = joinString(props.reportingDeadlines);
    const form = useFormObject();

    return (
        <div>
            <Cards data-tid="cards">
                {props.name && <FormName data-tid="formName">{props.name}</FormName>}
                <Condition
                    relevance={props.relevance}
                    relevanceMessage={props.relevanceMessage}
                    version={props.version}
                    periodDescription={props.periodDescription}
                />
                {props.periodBeginNew && !form.settings.isReadOnly && (
                    <PeriodBeginNew periodBeginNew={props.periodBeginNew} />
                )}
                {props.dateRelease && <DateRelease dateRelease={props.dateRelease} />}
                {props.notice && <LinkInfo notice={props.notice} />}
            </Cards>
            {props.reportingDeadlines && <CalendarInfo text={joinReportingDeadlines} />}
        </div>
    );
};

export const htmlWithLinkToTextOrNode = (hintText: React.ReactNode | string) => {
    if (typeof hintText === "string") {
        return hintText;
    }
    if (React.isValidElement(hintText)) {
        return <HintWithLink dangerouslySetInnerHTML={{ __html: hintText.props.children }} />;
    }
    return undefined;
};
